import { RegexValidator } from './RegexValidator'

export const EMAIL_REGEX =
    //eslint-disable-next-line
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export class EmailValidator extends RegexValidator {
    constructor() {
        super(EMAIL_REGEX, 'validations.email')
    }
}

export const EMAIL_VALIDATOR = new EmailValidator()
